import SafeImage from '@ui/SafeImage';
import { CategoryDocument } from 'models/category';

type Props = {
  category: CategoryDocument;
  onClick: (c: CategoryDocument) => void;
  selectedCategory: CategoryDocument | undefined;
};

export const ListingCard = ({ category, onClick }: Props) => {
  return (
    <button
      className="group flex h-40 w-full flex-row-reverse md:flex-col md:items-start justify-between items-center overflow-hidden rounded-3xl bg-light-grey hover:border hover:border-brand-secondary md:h-[260px] md:w-[189px]"
      type="button"
      onClick={() => onClick(category)}
    >
      {category.name !== "Other" ?
        <SafeImage
          src={category.image}
          alt={`${category.name} + photo`}
          className="h-auto w-60 transition-all duration-150 ease-in-out group-hover:scale-110 md:h-full md:w-[189px]"
        />
        : <div className='flex-1' />}
      <span className="px-10 md:pb-10 text-left text-body-md font-semibold md:text-body-lg max-w-[164px]">
        {category.app_desc || category.name}
      </span>
    </button>
  );
};
